import { Frame } from '@/frame';
import { Button } from '@/ui/button/button.component';
import { ListView } from '@/ui/list-view/list-view.component';
import { Row } from '@/ui/table/row.component';
import { Link, RouteComponentProps } from '@reach/router';
import React, { ComponentType } from 'react';
import { getPaginationFromQuery } from 'shared/helpers/pagination.helper';
import { usePaginatedUrlQuery } from 'shared/hooks/url-query';
import {
  EquipmentsQueryVariables,
  ListEquipmentDataFragment,
  useEquipmentsQuery,
} from './list.generated';

export const List: ComponentType<RouteComponentProps> = (props) => {
  const [query] = usePaginatedUrlQuery();
  const { data, loading } = useEquipmentsQuery({
    variables: { pagination: getPaginationFromQuery(query) },
    fetchPolicy: 'network-only',
  });
  return (
    <>
      <Frame.SubTitle>Übersicht</Frame.SubTitle>
      <Frame.ActionBar>
        <Button label="Neue Ausstattung" linkTo="/locations/equipment/create" />
      </Frame.ActionBar>
      <Frame.Content>
        <ListView<ListEquipmentDataFragment, EquipmentsQueryVariables['query']>
          loading={loading}
          data={data?.adminEquipments?.data || []}
          totalCount={data?.adminEquipments?.totalCount}
          columns={[
            {
              name: 'Name',
              sortable: true,
            },
            {
              name: 'Beschreibung',
              sortable: true,
            },
          ]}
          renderFilter={({ value, onChange }) => (
            <>
              {/* /*
              <Filter
                value={value || ''}
                onChange={onChange}
                placeholder={'Suche…'}
                loading={loading}
              />{' '} */}
            </>
          )}
          renderRow={(item) => (
            <Row key={item.id}>
              <td>
                <Link to={`../${item.id}/edit`}>{item.name}</Link>
              </td>
              <td>
                <Link to={`../${item.id}/edit`}>{item.description}</Link>
              </td>
            </Row>
          )}
        />
      </Frame.Content>
    </>
  );
};
